import { FC } from 'react';
import { EmptyState } from './empty-state';

import { pxToRem } from '@/theme/typography';
import { useTheme } from '@mui/material';

const emptyMoviesImg = '/icons/shared/movies-empty.svg';

interface MovieEmptyState {
  title: string;
  imgWidth?: { tablet: string };
}
export const MovieEmptyState: FC<MovieEmptyState> = ({ title, imgWidth }) => {
  const theme = useTheme();

  return (
    <EmptyState
      img={emptyMoviesImg}
      imgWidth={{ mobile: '220px', ...imgWidth }}
      imgHeight={{
        mobile: '195.3px',
        tablet: pxToRem(446.67),
      }}
      title={title}
      sx={{
        margin: 'auto',
      }}
      titleSx={{
        marginTop: '10px',
        color: theme.palette.grey[50],
        fontSize: {
          mobile: '16px',
          tablet: pxToRem(20),
        },
      }}
    />
  );
};
